module.exports = __webpack_public_path__ + "9afc1efb84695fa32520176266b9fce6.svg";